import { Apis } from "./index";


class ApiEnrolledThing {

    static fetchAll() {
        return Apis.get('/api/enrolled-thing/').then((value) => {
            return value;
        });
    }

    static updateSettings(enrolledThingId, settings) {
        return Apis.post(`/api/enrolled-thing/${enrolledThingId}`, settings);
    }

    static update({
        enrolledThingId,
        name,
    }) {
        return Apis.put(`/api/enrolled-thing/${enrolledThingId}`, { name });
    }

    static led({
        enrolledThingId,
        status,
    }){
        return Apis.post(`/api/enrolled-thing/${enrolledThingId}/led/${status}`);
    }



}

export { ApiEnrolledThing };